export default __webpack_public_path__ + "static/media/Boletim_20272596.7e659004.pdf";